import React, { useRef, Dispatch, FC, SetStateAction } from "react";
import TabFilters from "components/TabFilters";
import { Transition } from "@headlessui/react";
import { CategoryData, Product, menuSchedule } from "data/data";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import TabCategoriesFilter from "./TabCategoriesFilter";
import MenuScheduleFilter from "./MenuScheduleFilter";
import Cookies from "js-cookie";
import { useRestaurantStatus } from "../../src/hooks/useRestaurantStatus";
import { MenuPageHeaderSkeleton } from "shared/OnlineOrderingSkeletons";
export interface HeaderFilterSectionProps {
  className?: string;
  setItemData?: Dispatch<SetStateAction<Product[]>>;
  itemData?: Product[];
  renderAllData?: () => void;
  categoryData?: CategoryData[];
  menuScheduleData?: menuSchedule[];
  searchProduct?: any;
  getItemData?: any;
  setActivity?: any;
  imageUrl?: string;
  onlineOrderSettings: any;
  loading: boolean;
}

const HeaderFilterSection: FC<HeaderFilterSectionProps> = ({
  className = "mb-12",
  setItemData,
  itemData,
  renderAllData,
  categoryData,
  menuScheduleData,
  searchProduct,
  getItemData,
  setActivity,
  imageUrl,

  onlineOrderSettings,
  loading,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  // const [tabActive, setTabActive] = React.useState("All items");
  const navigate = useNavigate();
  // const [showComponent, setShowComponent] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState<
    menuSchedule[] | null
  >(null);
 
  const [modalOpen, setModalOpen] = useState<boolean>(false);
 
  const [hasError, setHasError] = useState(false);
  
  // Use the custom hook for real-time restaurant status
  const status = useRestaurantStatus({ 
    menuScheduleData: menuScheduleData || [], 
    updateInterval: 60000 // Update every minute
  });

  const handlemenuSchedule = () => {
    if (menuScheduleData) {
      setSelectedSchedule(menuScheduleData);
      setModalOpen(true);
    }
  };

  useEffect(() => {
    const MERCHANT_STORAGE_KEY = "merchantname";

    const merchantname = Cookies.get(MERCHANT_STORAGE_KEY);

    if (hasError === true) {
      navigate(`/${merchantname}/Page404`);
    }
  }, [hasError === true]);

  if (loading) {
    return <MenuPageHeaderSkeleton className={className} />;
  }
  return (
    <>
      <div className={` flex flex-col relative ${className}`}>
        {imageUrl && (
          <div className="relative w-full">
            {/* The image with rounded corners, dull effect, and fade-in animation */}
            <img
              src={onlineOrderSettings?.image}
              alt=""
              className="w-full object-cover rounded-lg animate-fade-in"
              style={{
                maxHeight: "30vh",
                objectFit: "cover",
                filter: "brightness(50%)", // Makes the image duller
              }}
            />
            {/* Overlaying the text with animations */}
            <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center">
              <h1 className="text-cream text-2xl sm:text-3xl font-bold slide-in-left">
                {onlineOrderSettings?.titleText}
              </h1>
              <p className="text-cream text-md sm:text-lg text-center mx-auto slide-in-left justify-center max-w-[80%]">
                {onlineOrderSettings?.customTextOne ?? "Default Text"}
              </p>
            </div>
          </div>
        )}

        <div className="flex items-center space-x-2 mt-1">
          {/* Other elements like status and buttons */}
        </div>

        <div className="flex items-center space-x-2 mt-4 mb-2">
          <h3
            className="px-3 py-1 rounded-lg"
            style={{ backgroundColor: status?.color }}
          >
            {status?.text}
          </h3>
          <button
            className="bg-grey-500 dark:text-gray-100  px-3 py-1 rounded-lg focus:outline-black focus:ring focus:ring-grey"
            onClick={handlemenuSchedule}
          >
            Hours
          </button>
        </div>
        <div className="menu-title-row"></div>
        <div className="flex flex-col lg:flex-row lg:items-center justify-between space-y-6 lg:space-y-0 lg:space-x-2 ">
          <div className="flex gap-2 w-full">
            <TabCategoriesFilter
              categoryData={categoryData}
              setItemData={setItemData}
              renderAllData={renderAllData}
              searchProduct={searchProduct}
            />
          </div>
          <span className="block flex-shrink-0"></span>
        </div>
        <Transition
          show={isOpen}
          enter="transition-opacity duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="w-full border-b "></div>
          <TabFilters
            getItemData={getItemData}
            categoryData={categoryData}
            itemData={itemData}
            setItemData={setItemData}
            renderAllData={renderAllData}
            isCategoryFilter={false}
          />
        </Transition>
      </div>

      {selectedSchedule && (
        <MenuScheduleFilter
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          menuschedule={selectedSchedule || []}
        />
      )}
    </>
  );
};

export default HeaderFilterSection;
